import React, { useState, useEffect } from 'react';
import { AssignCaseworkerCourseDialogComponent } from './assign-caseworker-for-course-component';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { useAuthenticatedUser } from '../../../../authentication';

export interface IAssignCaseworkerCourseDialogProps {
  courseIds?: string[];
}
const organizationClient = moduleClientFactory.createOrganizationClient(true);
const attendanceClient = moduleClientFactory.createAttendanceClient(true);
export function AssignCaseworkerCourseDialog({ courseIds }: IAssignCaseworkerCourseDialogProps) {
  const [userId, setUserId] = useState<string | undefined>();
  const [teamId, setTeamId] = useState<string | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const currentUserId = useAuthenticatedUser()?.profile.id;

  async function setTeamForUserId(id: string | undefined) {
    if (id) {
      const response = await organizationClient.getUserById({ userId: id });
      setTeamId(response.user?.teamId);
    } else {
      setTeamId(undefined);
    }
  }

  useEffect(() => {
    if (isOpen) {
      setIsConfirmed(false);
      setUserId(currentUserId);
      if (currentUserId) {
        setTeamForUserId(currentUserId);
      }
    }
  }, [currentUserId, isOpen]);

  async function handleConfirm() {
    setIsConfirmed(true);
    try {
      await attendanceClient.assignResponsibleCaseworkerToCourses({
        courseids: courseIds,
        teamId,
        caseWorkerId: userId,
      });
    } finally {
      setIsOpen(false);
    }
  }

  function handleTeamChange(value: string | undefined) {
    setTeamId(value);
    setUserId(undefined);
  }

  async function handleUserChange(selectedUserId: string | undefined) {
    setUserId(selectedUserId);
    await setTeamForUserId(selectedUserId ?? currentUserId);
  }

  if (!isOpen) {
    return null;
  }

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <AssignCaseworkerCourseDialogComponent
      onConfirm={handleConfirm}
      onTeamChange={handleTeamChange}
      onUserChange={handleUserChange}
      teamId={teamId}
      userId={userId}
      isOpen={isOpen}
      onClose={handleClose}
      isLoading={isConfirmed}
    />
  );
}
